/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsPrinter: {
  name: 'printer';
  data: string;
} = {
  name: 'printer',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 3a2 2 0 0 0-2 2v2H4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2h2a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-2V5a2 2 0 0 0-2-2H8Zm0 15v1h8v-4H8v3Zm-2-1H4V9h3a.996.996 0 0 0 .411-.088A2 2 0 0 0 8 9h8c.205 0 .403-.03.589-.088A.997.997 0 0 0 17 9h3v8h-2v-2a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v2ZM8 5h8v2H8V5Z" fill="currentColor"/></svg>`,
};
